<input [type]="inputType" value="{{text}}">
<span (click)="toggleMask($event)">
<span><img src="../../../../assets/close-eye.svg" class="show_hideIcon" *ngIf="masked" alt="maskedText"></span>
<span><img src="../../../../assets/open-eye.svg" class="show_hideIcon" *ngIf="!masked" alt="maskedText"></span>
</span>

